const expenseEn = {
  navigation: { expenses: 'Expenses' },
  roles: { modal: { form: { categories: { expenses: 'Expenses' } } } },
  dashboard: {
    kpis: {
      todayExpenses: 'Expenses today',
      monthExpenses: 'Expenses this month',
      todayNet: 'Net today',
      monthNet: 'Net this month',
      monthProfit: 'Profit this month',
    },
  },
  expenses: {
    title: 'Expenses',
    subtitle: 'Money going out of the store',
    tabs: { expenses: 'Expenses', recurring: 'Recurring', money: 'Money movements' },
    fallback: {
      message: 'Select a store to manage expenses.',
      subtitle: 'Select a store to manage expenses',
      goToStores: 'Go to stores',
    },
    fields: {
      category: 'Category',
      description: 'Description',
      amount: 'Amount',
      vatAmount: 'VAT amount',
      date: 'Date',
      paymentMethod: 'Payment method',
      supplier: 'Supplier',
      noSupplier: 'No supplier',
      reference: 'Reference',
      status: 'Status',
    },
    categories: {
      Rent: 'Rent',
      Utilities: 'Utilities',
      Supplies: 'Supplies',
      Marketing: 'Marketing',
      Insurance: 'Insurance',
      Software: 'Software',
      Maintenance: 'Maintenance',
      ProfessionalServices: 'Professional services',
      Taxes: 'Taxes',
      Inventory: 'Inventory',
      Other: 'Other',
    },
    status: { Active: 'Posted', Voided: 'Voided', Scheduled: 'Scheduled', scheduled: 'Scheduled' },
    actions: { create: 'Add expense', edit: 'Edit', void: 'Void' },
    dialog: { createTitle: 'New expense', editTitle: 'Edit expense' },
    filters: { from: 'From', to: 'To' },
    empty: 'No expenses in this period.',
    feedback: { saved: 'Expense saved.', voided: 'Expense voided.' },
    void: { title: 'Void this expense?', message: 'The expense is removed from the totals.' },
    money: {
      help: 'Money in compared with posted expenses for the selected dates.',
      in: 'Money in',
      out: 'Money out',
      net: 'Net',
      scheduled: 'Scheduled',
      unavailable: '—',
    },
    payroll: { expensesPaid: 'Expenses paid', netResult: 'Net result' },
    recurrence: {
      enable: 'Repeat',
      enableHelp: 'Future dates stay scheduled until they are due.',
      frequency: 'Repeats',
      interval: 'Every',
      endMode: 'Ends',
      occurrenceCount: 'Number of times',
      endDate: 'End date',
      preview: 'Next dates: {{dates}}',
    },
    frequency: { Weekly: 'Weekly', Monthly: 'Monthly', Yearly: 'Yearly' },
    endMode: { Never: 'Never', AfterCount: 'After a number of times', OnDate: 'On a date' },
    scope: {
      editTitle: 'Which expenses should change?',
      deleteTitle: 'Which expenses should be voided?',
      OnlyThis: 'Only this one',
      ThisAndFuture: 'This and future ones',
      All: 'All, including past ones',
      allWarning: 'This changes every occurrence in the series, including ones already posted.',
    },
    validation: {
      categoryRequired: 'Choose a category.',
      descriptionRequired: 'Enter a description.',
      amountRequired: 'Amount must be greater than 0.',
      vatInvalid: 'VAT must be between 0 and the amount.',
      dateRequired: 'Choose a date.',
      paymentMethodRequired: 'Choose an in-store payment method.',
      frequencyRequired: 'Choose how often it repeats.',
      intervalRequired: 'The interval must be at least 1.',
      endModeRequired: 'Choose when it ends.',
      occurrenceCountRequired: 'Enter how many times it repeats.',
      endDateRequired: 'Choose an end date.',
      endDateBeforeStart: 'The end date cannot be before the start.',
    },
    errors: {
      load: 'Could not load expenses.',
      save: 'Could not save the expense.',
      void: 'Could not void the expense.',
      notFound: 'Expense not found.',
      readOnly: 'Purchase expenses change only when the purchase is voided.',
      recurrenceInvalid: 'The repeat schedule is not valid.',
      scopeInvalid: 'That change is not allowed for this expense.',
    },
  },
};

const expensePt = {
  navigation: { expenses: 'Despesas' },
  roles: { modal: { form: { categories: { expenses: 'Despesas' } } } },
  dashboard: {
    kpis: {
      todayExpenses: 'Despesas hoje',
      monthExpenses: 'Despesas este mês',
      todayNet: 'Resultado hoje',
      monthNet: 'Resultado este mês',
      monthProfit: 'Lucro este mês',
    },
  },
  expenses: {
    title: 'Despesas',
    subtitle: 'Dinheiro a sair da loja',
    tabs: { expenses: 'Despesas', recurring: 'Recorrentes', money: 'Movimentos de dinheiro' },
    fallback: {
      message: 'Selecione uma loja para gerir as despesas.',
      subtitle: 'Selecione uma loja para gerir as despesas',
      goToStores: 'Ir para lojas',
    },
    fields: {
      category: 'Categoria',
      description: 'Descrição',
      amount: 'Valor',
      vatAmount: 'Valor de IVA',
      date: 'Data',
      paymentMethod: 'Método de pagamento',
      supplier: 'Fornecedor',
      noSupplier: 'Sem fornecedor',
      reference: 'Referência',
      status: 'Estado',
    },
    categories: {
      Rent: 'Renda',
      Utilities: 'Serviços',
      Supplies: 'Consumíveis',
      Marketing: 'Marketing',
      Insurance: 'Seguro',
      Software: 'Software',
      Maintenance: 'Manutenção',
      ProfessionalServices: 'Serviços profissionais',
      Taxes: 'Impostos',
      Inventory: 'Inventário',
      Other: 'Outra',
    },
    status: { Active: 'Lançada', Voided: 'Anulada', Scheduled: 'Agendada', scheduled: 'Agendada' },
    actions: { create: 'Adicionar despesa', edit: 'Editar', void: 'Anular' },
    dialog: { createTitle: 'Nova despesa', editTitle: 'Editar despesa' },
    filters: { from: 'De', to: 'Até' },
    empty: 'Não há despesas neste período.',
    feedback: { saved: 'Despesa guardada.', voided: 'Despesa anulada.' },
    void: { title: 'Anular esta despesa?', message: 'A despesa deixa de contar nos totais.' },
    money: {
      help: 'Dinheiro a entrar comparado com as despesas lançadas nas datas escolhidas.',
      in: 'Entradas',
      out: 'Saídas',
      net: 'Resultado',
      scheduled: 'Agendado',
      unavailable: '—',
    },
    payroll: { expensesPaid: 'Despesas pagas', netResult: 'Resultado líquido' },
    recurrence: {
      enable: 'Repetir',
      enableHelp: 'As datas futuras ficam agendadas até serem devidas.',
      frequency: 'Repete',
      interval: 'A cada',
      endMode: 'Termina',
      occurrenceCount: 'Número de vezes',
      endDate: 'Data de fim',
      preview: 'Próximas datas: {{dates}}',
    },
    frequency: { Weekly: 'Semanal', Monthly: 'Mensal', Yearly: 'Anual' },
    endMode: { Never: 'Nunca', AfterCount: 'Após um número de vezes', OnDate: 'Numa data' },
    scope: {
      editTitle: 'Que despesas devem mudar?',
      deleteTitle: 'Que despesas devem ser anuladas?',
      OnlyThis: 'Só esta',
      ThisAndFuture: 'Esta e as futuras',
      All: 'Todas, incluindo as passadas',
      allWarning: 'Isto altera todas as ocorrências da série, incluindo as já lançadas.',
    },
    validation: {
      categoryRequired: 'Escolha uma categoria.',
      descriptionRequired: 'Indique uma descrição.',
      amountRequired: 'O valor tem de ser maior que 0.',
      vatInvalid: 'O IVA tem de estar entre 0 e o valor.',
      dateRequired: 'Escolha uma data.',
      paymentMethodRequired: 'Escolha um método de pagamento na loja.',
      frequencyRequired: 'Escolha a frequência.',
      intervalRequired: 'O intervalo tem de ser pelo menos 1.',
      endModeRequired: 'Escolha quando termina.',
      occurrenceCountRequired: 'Indique quantas vezes se repete.',
      endDateRequired: 'Escolha a data de fim.',
      endDateBeforeStart: 'A data de fim não pode ser anterior ao início.',
    },
    errors: {
      load: 'Não foi possível carregar as despesas.',
      save: 'Não foi possível guardar a despesa.',
      void: 'Não foi possível anular a despesa.',
      notFound: 'Despesa não encontrada.',
      readOnly: 'As despesas de compras só mudam quando a compra é anulada.',
      recurrenceInvalid: 'A repetição não é válida.',
      scopeInvalid: 'Essa alteração não é permitida nesta despesa.',
    },
  },
};

const expenseEs = {
  navigation: { expenses: 'Gastos' },
  roles: { modal: { form: { categories: { expenses: 'Gastos' } } } },
  dashboard: {
    kpis: {
      todayExpenses: 'Gastos hoy',
      monthExpenses: 'Gastos este mes',
      todayNet: 'Resultado hoy',
      monthNet: 'Resultado este mes',
      monthProfit: 'Beneficio este mes',
    },
  },
  expenses: {
    title: 'Gastos',
    subtitle: 'Dinero que sale de la tienda',
    tabs: { expenses: 'Gastos', recurring: 'Recurrentes', money: 'Movimientos de dinero' },
    fallback: {
      message: 'Seleccione una tienda para gestionar los gastos.',
      subtitle: 'Seleccione una tienda para gestionar los gastos',
      goToStores: 'Ir a tiendas',
    },
    fields: {
      category: 'Categoría',
      description: 'Descripción',
      amount: 'Importe',
      vatAmount: 'Importe de IVA',
      date: 'Fecha',
      paymentMethod: 'Método de pago',
      supplier: 'Proveedor',
      noSupplier: 'Sin proveedor',
      reference: 'Referencia',
      status: 'Estado',
    },
    categories: {
      Rent: 'Alquiler',
      Utilities: 'Suministros',
      Supplies: 'Consumibles',
      Marketing: 'Marketing',
      Insurance: 'Seguro',
      Software: 'Software',
      Maintenance: 'Mantenimiento',
      ProfessionalServices: 'Servicios profesionales',
      Taxes: 'Impuestos',
      Inventory: 'Inventario',
      Other: 'Otro',
    },
    status: { Active: 'Contabilizado', Voided: 'Anulado', Scheduled: 'Programado', scheduled: 'Programado' },
    actions: { create: 'Añadir gasto', edit: 'Editar', void: 'Anular' },
    dialog: { createTitle: 'Nuevo gasto', editTitle: 'Editar gasto' },
    filters: { from: 'Desde', to: 'Hasta' },
    empty: 'No hay gastos en este periodo.',
    feedback: { saved: 'Gasto guardado.', voided: 'Gasto anulado.' },
    void: { title: '¿Anular este gasto?', message: 'El gasto deja de contar en los totales.' },
    money: {
      help: 'Dinero entrante comparado con los gastos contabilizados en las fechas elegidas.',
      in: 'Entradas',
      out: 'Salidas',
      net: 'Resultado',
      scheduled: 'Programado',
      unavailable: '—',
    },
    payroll: { expensesPaid: 'Gastos pagados', netResult: 'Resultado neto' },
    recurrence: {
      enable: 'Repetir',
      enableHelp: 'Las fechas futuras quedan programadas hasta que vencen.',
      frequency: 'Se repite',
      interval: 'Cada',
      endMode: 'Termina',
      occurrenceCount: 'Número de veces',
      endDate: 'Fecha de fin',
      preview: 'Próximas fechas: {{dates}}',
    },
    frequency: { Weekly: 'Semanal', Monthly: 'Mensual', Yearly: 'Anual' },
    endMode: { Never: 'Nunca', AfterCount: 'Tras un número de veces', OnDate: 'En una fecha' },
    scope: {
      editTitle: '¿Qué gastos deben cambiar?',
      deleteTitle: '¿Qué gastos deben anularse?',
      OnlyThis: 'Solo este',
      ThisAndFuture: 'Este y los futuros',
      All: 'Todos, incluidos los pasados',
      allWarning: 'Esto cambia todas las ocurrencias de la serie, incluidas las ya contabilizadas.',
    },
    validation: {
      categoryRequired: 'Elija una categoría.',
      descriptionRequired: 'Indique una descripción.',
      amountRequired: 'El importe debe ser mayor que 0.',
      vatInvalid: 'El IVA debe estar entre 0 y el importe.',
      dateRequired: 'Elija una fecha.',
      paymentMethodRequired: 'Elija un método de pago en tienda.',
      frequencyRequired: 'Elija la frecuencia.',
      intervalRequired: 'El intervalo debe ser al menos 1.',
      endModeRequired: 'Elija cuándo termina.',
      occurrenceCountRequired: 'Indique cuántas veces se repite.',
      endDateRequired: 'Elija la fecha de fin.',
      endDateBeforeStart: 'La fecha de fin no puede ser anterior al inicio.',
    },
    errors: {
      load: 'No se pudieron cargar los gastos.',
      save: 'No se pudo guardar el gasto.',
      void: 'No se pudo anular el gasto.',
      notFound: 'Gasto no encontrado.',
      readOnly: 'Los gastos de compras solo cambian cuando se anula la compra.',
      recurrenceInvalid: 'La repetición no es válida.',
      scopeInvalid: 'Ese cambio no está permitido en este gasto.',
    },
  },
};

export const expenseTranslationsEn = expenseEn;
export const expenseTranslationsPt = expensePt;
export const expenseTranslationsEs = expenseEs;
